import { render, staticRenderFns } from "./ManagementInformation.vue?vue&type=template&id=b532328c"
import script from "./ManagementInformation.vue?vue&type=script&lang=js"
export * from "./ManagementInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports